import styled from "styled-components";
import React from "react";
import { DefaultTheme } from "styled-components";

const MainContainer = styled.div`
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.colors.background};
`;

const OrbContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 0;
`;

const Orb = styled.div<{
  $top: string;
  $left: string;
  $size: string;
  $color: (props: { theme: DefaultTheme }) => string;
  $delay: string;
}>`
  position: absolute;
  top: ${(props) => props.$top};
  left: ${(props) => props.$left};
  width: ${(props) => props.$size};
  height: ${(props) => props.$size};
  background-color: ${(props) => props.$color};
  border-radius: 50%;
  opacity: 0.15;
  filter: blur(40px);
  animation: pulse 8s infinite ${(props) => props.$delay};

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0.15;
    }
    50% {
      transform: scale(1.1);
      opacity: 0.2;
    }
    100% {
      transform: scale(1);
      opacity: 0.15;
    }
  }
`;

const Container = styled.div`
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  padding-top: 88px;

  @media (max-width: 768px) {
    padding: 0;
    padding-top: 88px;
  }
`;

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <MainContainer>
      <OrbContainer>
        <Orb
          $top="-5%"
          $left="-5%"
          $size="300px"
          $color={({ theme }: { theme: DefaultTheme }) =>
            theme.colors.verae[300]
          }
          $delay="0s"
        />
        <Orb
          $top="30%"
          $left="80%"
          $size="350px"
          $color={({ theme }: { theme: DefaultTheme }) =>
            theme.colors.purple[400]
          }
          $delay="1s"
        />
        <Orb
          $top="70%"
          $left="20%"
          $size="250px"
          $color={({ theme }: { theme: DefaultTheme }) =>
            theme.colors.verae[200]
          }
          $delay="2s"
        />
        <Orb
          $top="60%"
          $left="90%"
          $size="200px"
          $color={({ theme }: { theme: DefaultTheme }) =>
            theme.colors.purple[300]
          }
          $delay="3s"
        />
      </OrbContainer>
      <Container>{children}</Container>
    </MainContainer>
  );
};
